export { default as ShopifyGeoSpatialDashboard } from "./ShopifyGeoSpatialDashboard";
